import type { ReactNode } from 'react'
import { Timeline } from 'primereact/timeline'
import StatusTag from './StatusTag'

/**
 * Paylaşılan işlem geçmişi timeline'ı (013 tasarım dili — FR-010). PrimeReact Timeline üzerine kurulu
 * (davranış/erişilebilirlik zemini kütüphaneden); görünüm token'larla temalanır. Reuse Mandate.
 */
export interface TimelineEvent {
  title: string
  /** Alt açıklama / zaman-kişi meta satırı. */
  meta?: string
  /** Karar bekleyen adım vurgusu için 'pending'; tamamlanan için 'done'. */
  state?: 'done' | 'pending'
  /** Verilirse başlık düz metin yerine durum rozeti (StatusTag; kendi tag rengiyle) olarak render edilir. */
  statusId?: number
  /** Meta altında serbest içerik (ör. denetim logu değişiklik satırları: "Ad: eski → yeni"). */
  details?: ReactNode
  /** En son eklenen olayı vurgular (marker'a `latest` sınıfı) — diğerlerinden ayırt etmek için. */
  highlight?: boolean
}

export interface HistoryTimelineProps {
  events: TimelineEvent[]
}

export default function HistoryTimeline({ events }: Readonly<HistoryTimelineProps>) {
  const content = (e: TimelineEvent) => (
    <div className="ui-timeline-body">
      {e.statusId != null ? (
        <StatusTag statusId={e.statusId} label={e.title} />
      ) : (
        <span className="ui-timeline-label">{e.title}</span>
      )}
      {e.meta && (
        <span className={e.state === 'pending' ? 'ui-timeline-pending' : 'ui-timeline-meta'}>
          {e.meta}
        </span>
      )}
      {e.details && <div className="ui-timeline-details">{e.details}</div>}
    </div>
  )
  const marker = (e: TimelineEvent) => (
    <span
      className={`ui-timeline-dot${e.state === 'pending' ? ' pending' : ''}${e.highlight ? ' latest' : ''}`}
      aria-hidden
    />
  )
  return <Timeline value={events} content={content} marker={marker} className="ui-timeline" />
}
